import {Icon} from 'antd'

const IconFont = Icon.createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_961570_wqxvwvwn7gk.js',
});
IconFont.pre = 'prop'
export default IconFont